
import * as Sentry from '@sentry/vue'
import { Component, Vue } from 'vue-property-decorator'
import CharacterForm from '@/components/character_form.vue'
import { Character } from '@/interfaces/character'
import { CreateResponse, CharacterCreateErrors } from '@/interfaces/responses'
import SavageAimMixin from '@/mixins/savage_aim_mixin'

@Component({
  components: {
    CharacterForm,
  },
})
export default class NewChar extends SavageAimMixin {
  errors: string[] = []

  loading = false

  url = `${process.env.VUE_APP_URL}/backend/api/character/`

  get urlInput(): HTMLInputElement {
    return this.$refs.url as HTMLInputElement
  }

  mounted(): void {
    document.title = 'Add New Character - Savage Aim'
  }

  async sendCharacter(char: Character): Promise<void> {
    // Function that is solely for handling interacting with the savageaim api
    // No need for try / catch since it's called inside a try catch block already
    this.loading = true
    const body = JSON.stringify(char)
    try {
      const response = await fetch(this.url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Vue.$cookies.get('csrftoken'),
        },
        body,
      })

      if (response.ok) {
        // Attempt to parse the json, get the id, and then redirect
        const json = await response.json() as CreateResponse
        this.$store.dispatch('fetchCharacters')
        this.$router.push(`/characters/${json.id}/`, () => {
          Vue.notify({ text: `New Character created successfully!`, type: 'is-success' })
        })
      }
      else {
        super.handleError(response.status)
        const json = await response.json() as CharacterCreateErrors
        if (json.lodestone_id != null) {
          this.errors = json.lodestone_id
        }
        // Catch all error message for anything other than lodestone id
        else if (Object.keys(json).length > 0) {
          this.errors = ['Something went wrong that shouldn\'t have, please inform Eri on the Discord. Sorry for the inconvenience!']
        }
      }
    }
    catch (e) {
      this.$notify({ text: `Error ${e} when attempting to create Character.`, type: 'is-danger' })
      Sentry.captureException(e)
    }
    finally {
      this.loading = false
    }
  }
}
